module.exports = __webpack_public_path__ + "img/Rectangle 7.ccfb37c7.png";